import { init } from './app/init.js';

export { init };

export function initAll() {
  const roots = document.querySelectorAll('[data-gpx-analyzer]');
  for (const root of roots) init(root);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

